import { render, staticRenderFns } from "./TransactionGroup.vue?vue&type=template&id=a182dda8&scoped=true&"
import script from "./TransactionGroup.vue?vue&type=script&lang=js&"
export * from "./TransactionGroup.vue?vue&type=script&lang=js&"
import style0 from "./TransactionGroup.vue?vue&type=style&index=0&id=a182dda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a182dda8",
  null
  
)

export default component.exports